<!-- HowToUseDialog -->

<template>
  <van-dialog v-model="visibleCardInfo" :closeOnClickOverlay="true" :showConfirmButton="false">
    <div class="goods-notice" v-html="goods.notice"></div>
  </van-dialog>
</template>

<style scoped>
.goods-notice {
  padding: 10px 20px;
  max-height: 70vh;
  overflow-y: auto;
  word-break: break-all;
  word-wrap: break-word;
}
</style>

<script>
import { api_get_goods_by_id } from "@/api/goods-api"

export default {
  data() {
    return {
      goods: {},
      visibleCardInfo: false
    }
  },

  methods: {
    // 入口方法
    showHowToUse(goodsId) {
      budo_log.info("#294 dialog, showHowToUse, goodsId=", goodsId)

      this.visibleCardInfo = true

      api_get_goods_by_id(goodsId).then(res => {
        this.goods = res.data;
      })
    }
  }
}
</script>
